/* ==========================================================================
   MÓDULO: BOTÓN DE IMPRIMIR
   ========================================================================== */
export default function initPrintButton() {
  const printButton = document.querySelector(".js-print-button");
  if (!printButton) {
    return;
  }
  printButton.addEventListener("click", () => {
    window.print();
  });
}
